import request from '../utils/request.js'
//获取首页JSON数据
export function pageModule(pageId) {
  return request({
    url: process.env.PRODUCTURL + '/page/index/' + pageId,
    method: 'get',
  })
}
//获取商品分类数据
export function categoryModule(data) {
  return request({
    url: process.env.PRODUCTURL + '/page/index/getFeedsModule',
    method: 'post',
    data: data
  })
}
//预览page页面
export function pageIdModule(data) {
  return request({
    url: process.env.PRODUCTURL + '/page/index/' + data,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/cms.js